<div class="form-creation">
    <div class="form-aside">
        <div class="neo-tabs">
            <div class="neo-tab" [class.active]="selectedTab === 'sections'" (click)="selectTab('sections')">
                Sections
            </div>
            <div class="neo-tab" [class.active]="selectedTab === 'fields'" (click)="selectTab('fields')">
                Fields
            </div>
            <div class="neo-tab" [class.active]="selectedTab === 'custom_fields'" (click)="selectTab('custom_fields')">
                Custom Fields
            </div>
        </div>
        <div class="form-aside-search">
            <div class="neo-search-container" [formGroup]="searchForm">
                <em class="pi pi-search neo-search-icon"></em>
                <input class="neo-search-input" type="text" id="form_sections_fields_search" formControlName="search"
                    [placeholder]="'Search ' + (selectedTab === 'sections' ? 'sections ...' : 'fields ...')"
                    [attr.aria-label]="'Search input'">
            </div>
        </div>
        @if (selectedTab === "sections") {
        <div class="form-sections neo-scrollbar">
            <div cdkDropList #availableSections="cdkDropList" id="availableSectionsList"
                [cdkDropListData]="availableFormFields" [cdkDropListConnectedTo]="['formLayout']"
                (cdkDropListDropped)="drop($event)" class="form-sections-list">
                <div *ngFor="let section of availableFormFields; trackBy: trackById" cdkDrag [cdkDragData]="section"
                    class="form-section-card">
                    <div class="form-section-image">
                        <img src="./assets/icons-svg/section.svg" />
                    </div>
                    <div class="form-section-header">
                        <div class="form-section-name">
                            {{ section.section_label }}
                            <!-- <em class="pi pi-grip-vertical drag-handle"></em> -->
                        </div>
                        <div class="form-section-count">
                            {{ section.section_form_fields.length }} fields
                        </div>
                    </div>
                </div>
            </div>

            <empty-state *ngIf="!availableFormFields.length && !isLoading && !searchForm.get('search')?.value">
                <empty-state-title>No Available Sections</empty-state-title>
                <empty-state-subtitle>All sections have been added to the form.</empty-state-subtitle>
            </empty-state>

            <empty-state *ngIf="!availableFormFields.length && !isLoading && searchForm.get('search')?.value">
                <empty-state-title>No Results Found</empty-state-title>
                <empty-state-subtitle>
                    No sections match your search. Try adjusting your search term.
                </empty-state-subtitle>
            </empty-state>
        </div>
        }
        @if (selectedTab === "fields") {
        <div class="form-fields neo-scrollbar">
            <div *ngFor="let section of fieldsData; let i = index" class="section-fields">
                <div class="form-field-header" [class.first]="i === 0" (click)="toggleSection(section)">
                    <span class="section-name">
                        {{ section.section_label }}
                    </span>
                    <i [class]="section.expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
                </div>

                <div *ngIf="section.expanded" cdkDropList [id]="'fields_' + section.section_id"
                    [cdkDropListData]="section.section_form_fields"
                    [cdkDropListConnectedTo]="getConnectedFieldsList(section.section_id)"
                    (cdkDropListDropped)="drop($event)" class="form-fields-list">
                    <div *ngFor="let field of getVisibleFields(section)" class="field-card"
                        [class.disabled]="field['disabled']"
                        [class.group-field]="field.element_type === 'group'" cdkDrag [cdkDragData]="field">

                        <div class="field-wrapper">
                            <div class="field-main-info">
                                <span class="form-field-name">{{ field.label }}</span>
                                <div class="field-badges">
                                    <span class="type-badge">{{ field.type || field.element_type }}</span>
                                    <span *ngIf="field.parent_group" class="group-badge">
                                        {{ field.group_label }}
                                    </span>
                                </div>
                            </div>
                            <i class="pi pi-grip-vertical drag-handle"></i>
                        </div>
                    </div>
                    <div *ngIf="getVisibleFields(section).length === 0 && section.section_form_fields.length !== 0" class="empty-section" style="padding: 0;">
                        No fields available in this section
                    </div>
                    <div *ngIf="section.section_form_fields.length === 0" class="empty-section" style="padding: 0;">
                        No fields available in this section
                    </div>
                </div>
            </div>
        </div>
        }
        @if (selectedTab === "custom_fields") {
        <div class="custom-field-section">
            <div class="form-fields neo-scrollbar">
                <div *ngIf="loadingCustomFields" class="center-loader">
                    <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
                    </p-progressSpinner>
                </div>
            
                <div *ngFor="let section of formCustomFields; let i = index" class="section-fields">
                    <div cdkDropList [id]="'fields_' + section.section_id" [cdkDropListData]="section.section_form_fields"
                        [cdkDropListConnectedTo]="getConnectedFieldsList(section.section_id)" (cdkDropListDropped)="drop($event)"
                        class="form-fields-list">
                        <div *ngFor="let field of getVisibleFields(section)" class="field-card" [class.disabled-custom-field]="field['disabled']"
                            [class.group-field]="field.element_type === 'group'" cdkDrag [cdkDragData]="field" 
                            [cdkDragDisabled]="field['disabled']">
                            <div class="field-wrapper">
                                <div class="field-main-info">
                                    <span class="form-field-name">{{ field.label }}</span>
                                    <div class="field-badges">
                                        <span class="type-badge">{{ field.type || field.element_type }}</span>
                                       <span *ngIf="field['disabled']" class="group-badge">
                                            Used
                                        </span>
                                    </div>
                                </div>
                                <div class="form-edit" style="cursor: pointer;" (click)="editCustomField(field)">
                                    <i class="pi pi-pen-to-square" style="color: #272727"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <empty-state style="height: 100%;"
                        *ngIf="!getVisibleFields(section).length && !loadingCustomFields && searchForm.get('search')?.value">
                        <empty-state-title>No Matching Sections Found</empty-state-title>
                        <empty-state-subtitle>
                            We couldn’t find any sections matching your search term.
                            You can still create a new one by clicking <strong>“Create Custom Field”</strong>.
                        </empty-state-subtitle>
                    </empty-state>
                </div>

                <empty-state style="height: 100%;"
                    *ngIf="!formCustomFields.length && !loadingCustomFields && !searchForm.get('search')?.value">
                    <empty-state-title>No Custom Fields Yet</empty-state-title>
                    <empty-state-subtitle>
                        You haven’t added any custom sections to this form yet.
                        Click <strong>“Create Custom Field”</strong> to add one and start customizing your form.
                    </empty-state-subtitle>
                </empty-state>

            </div>
            <div class="custom-fields-footer">
                <button pButton class="neo-btn outline" (click)="createCustomField()" [disabled]="formCustomFieldsCount >= formCustomFieldsMaxCount">
                    Add Custom Field
                </button>
                <small class="fields-created-count"><i class="pi pi-exclamation-circle"></i> Custom fields used: {{formCustomFieldsCount}} / {{formCustomFieldsMaxCount}} (all forms)</small>
            </div>
        </div>
        }
    </div>
    <div class="form-container">
        <div class="form-data">
            <div class="form-header">
                <div class="form-name">
                    {{formSettings.formName}}
                </div>
                <div class="form-type">
                    <span class="group-badge">
                        {{previousSelectedCategory | uppercase}}
                    </span>
                </div>
                <div class="form-edit" (click)="showFormDetailsEdit = true">
                    <img src="./assets/icons-svg/edit-2.svg" />
                </div>
                <div class="actions">
                    <div class="neo-action-item lg" (click)="showInfoSection = true"
                        pTooltip="Need help? See how to add sections, fields, and customize your form." tooltipPosition="bottom">
                        <i class="pi pi-info-circle"></i>
                    </div>
                    <div class="action-item" (click)="previewForm()">
                        <img src="./assets/icons-svg/eye.svg" />
                    </div>
                    <button class="neo-btn" (click)="saveForm()" [disabled]="!detector.isDirty">Save</button>
                </div>
            </div>
            <div class="form-content neo-scrollbar">
                <div class="neo-input-wrapper">
                    <label for="header_content" required>Header</label>
                    <div class="header-wrapper" style="position: relative;">
                        <input pInputText type="text" name="header_content" id="header_content" [(ngModel)]="headerContent"
                            (input)="onHeaderContentChange($event)" placeholder="Enter header content">
                        <div class="gradient-picker" [style.background]="formSettings.bg_colour | gradientCss"
                            (click)="gradientPickerPanel.toggle($event)">
                            <p-popover #gradientPickerPanel styleClass="no-padding-overlay gradient-picker">
                                <app-gradient-picker [maxColors]="3" #gradientPicker [gradient]="formSettings.bg_colour"
                                    (gradientChange)="headerBgGradientChange($event)"></app-gradient-picker>
                            </p-popover>
                        </div>
                    </div>
                    <small class="header-description"><i class="pi pi-exclamation-circle"></i> Use the color box on the right to choose a gradient for your header and footer. You can see how it looks in the form preview.</small>
                </div>
                <div class="neo-input-wrapper">
                    <label required>Body</label>
                    <div class="form-body" cdkDropList id="formLayout" #formLayout="cdkDropList"
                            [cdkDropListData]="formLayoutSections" [cdkDropListConnectedTo]="['availableSectionsList']"
                            (cdkDropListDropped)="drop($event)">

                        <div *ngIf="!formLayoutSections.length" class="empty-layout">
                            Drag sections here to build your form
                        </div>

                        <div *ngFor="let section of formLayoutSections; let i = index; trackBy: trackById" cdkDrag [cdkDragData]="section"
                            class="form-body-section">
                            <div class="body-section-heading">
                                {{section.section_label}}
                                <div class="form-section-action">
                                    <div class="section-action-item" *ngIf="((this.selectedCategory === 'registration' && section.section_label.toLowerCase().trim() !== 'personal info') || (this.selectedCategory === 'offer' && section.section_label.toLowerCase().trim() !== 'info') || (this.selectedCategory === 'feedback' && section.section_label.toLowerCase().trim() !== 'overall assessment') || (this.selectedCategory === 'documentation'))" (click)="deleteSection(i)">
                                        <img src="./assets/icons-svg/delete.svg" />
                                    </div>
                                </div>
                            </div>
                            <div cdkDropList [id]="'fields_' + section.section_id" [cdkDropListData]="section.section_form_fields"
                                [cdkDropListConnectedTo]="getConnectedFieldsList(section.section_id)" (cdkDropListDropped)="drop($event)"
                                class="body-section-content">
                                <div cdkDropList [id]="'sectionFields_' + section.section_id" [cdkDropListData]="section.section_form_fields"
                                    [cdkDropListConnectedTo]="getConnectedFieldsList(section.section_id)" (cdkDropListDropped)="drop($event)" class="body-section-fields">
                                    <div *ngIf="!section.section_form_fields.length" class="empty-layout">
                                        Drag fields here to build your form section
                                    </div>
                            
                                    <!-- [class.group-member]="field.parent_group" [class.selected]="selectedField === field" -->
                                    <div *ngFor="let field of section.section_form_fields; let j = index; trackBy: trackByFieldId" cdkDrag
                                        [cdkDragData]="field" class="body-section-item" [class.group-member]="field.parent_group"
                                        [class.selected]="selectedField === field" (click)="selectField(field, section)" [cdkDragDisabled]="(section.section_label.toLowerCase().trim() === 'personal info' && (field.name === 'email_id' || field.name === 'confirm_email_id'))">
                                        <div class="neo-input-wrapper">
                                            <div style="display: flex; gap: 8px;">
                                                <label [for]="field.id" [attr.required]="field.is_required || undefined" style="width: fit-content;">{{field.label}}</label>
                                                <div class="field-badges">
                                                    <span class="type-badge">{{ field.type || field.element_type }}</span>
                                                    <span *ngIf="field.parent_group" class="group-badge">
                                                        {{ field.group_label }}
                                                    </span>
                                                    <span *ngIf="field.section_label?.toLowerCase() === 'custom fields'" class="custom-badge">
                                                        Custom
                                                    </span>

                                                    <ng-template #dependentTooltip>
                                                        This field appears when:
                                                        <ol style="list-style-position: inside;">
                                                            <li *ngFor="let tooltip of isDependentField(field)">
                                                                <strong>{{tooltip.label}}</strong> = {{tooltip.option}}
                                                            </li>
                                                        </ol>
                                                    </ng-template>
                                                    <span [pTooltip]="dependentTooltip" *ngIf="isDependentField(field).length" class="custom-badge dependent-badge">
                                                        Dependent
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="input-field">
                                                @if (["input", "email", "number", "percentage", "date picker", "mobile"].includes(field.type?.toLowerCase() ?? '')) {
                                                <input readonly pInputText type="text" [name]="field.id" [id]="field.id" [placeholder]="field.placeholder ?? ''">
                                                } @else if (["radio", "checkbox"].includes(field.type?.toLowerCase() ?? '')) {
                                                <div style="display: flex; flex-direction: column; flex: 1; margin: 1vh 0;">
                                                    @for (option of field.options; track $index) {
                                                    <div style="display: flex; flex-direction: row; flex: 1; gap: 0.25rem; align-items: flex-start;">
                                                        @if (field.type?.toLowerCase() === "checkbox") {
                                                        <p-checkbox [id]="field.id" [inputId]="field.id + option.value" [value]="option.value" [name]="option.label"
                                                            [disabled]="true" [(ngModel)]="primeNgDummyModel"></p-checkbox>
                                                        } @else {
                                                        <p-radioButton [id]="field.id" [inputId]="field.id + option.value" [value]="option.value" [name]="option.label"
                                                            [disabled]="true" [(ngModel)]="primeNgDummyModel"></p-radioButton>
                                                        }
                                                        <label [for]="field.id + option.value" style="font-weight: 400;">
                                                            {{ option.label}}
                                                        </label>
                                                    </div>
                                                    }
                                                    @if (!field.options?.length) {
                                                    @if(field.name === "preferred_role") {
                                                    <small>The options for this field are dynamically populated from the event's job roles.</small>
                                                    } @else {
                                                    <small>This field has no options configured yet. Please add some options.</small>
                                                    }
                                                    }
                                                </div>
                                                } @else if (isDisplayFieldType(field.type)) {
                                                <div class="paragraph-canvas-preview">{{ field.description || 'Add the text this paragraph should display.' }}</div>
                                                } @else if (["textarea"].includes(field.type?.toLowerCase() ?? '')) {
                                                <textarea pInputTextarea [autoResize]="true" [rows]="3" [readOnly]="true" [disabled]="true" [readOnly]="true"></textarea>
                                                } @else if (["dropdown", "multi-dropdown"].includes(field.type?.toLowerCase() ?? '')) {
                                                <p-multiSelect [options]="field.options" [placeholder]="field.placeholder ?? ''" [readonly]="true" [disabled]="true">
                                                </p-multiSelect>
                                                } @else if(["file", "multi-file"].includes(field.type?.toLowerCase() ?? '')) {
                                                <div [disabled]="true" class="fileUpload-dropzone disable-input-field"
                                                    ngx-dropzone>
                                                    <ngx-dropzone-label>
                                                        <div class="dropzone-label">
                                                            <img src="assets/icons-svg/upload_file_icon.svg" alt="Upload" />
                                                            <p class="upload-text">
                                                                Drag & Drop your files here or
                                                                <span [style]="{ color: 'var(--fc-primary)', 'text-decoration': 'underline' }">
                                                                    Choose Files
                                                                </span>
                                                            </p>
                                                            <p class="format-text">
                                                                Recommended {{ field.properties?.file_format?.join(", ") }} only (Max File Size:
                                                                {{field.properties?.file_max_size}})
                                                            </p>
                                                        </div>
                                                    </ngx-dropzone-label>
                                                </div>
                                                } @else {
                                                <input readonly pInputText type="text" [name]="field.id" [id]="field.id" [placeholder]="field.placeholder ?? ''">
                                                }
                                                <div class="action-item" (click)="deleteField(i, j)"
                                                    *ngIf="!((section.section_label.toLowerCase().trim() === 'personal info' && (field.name === 'email_id' || field.name === 'confirm_email_id')) || (section.section_label.toLowerCase().trim() === 'overall assessment' && field.name === 'final_recommendation') || (section.section_label.toLowerCase().trim() === 'info' && field.name === 'offer_acceptance'))">
                                                    <img src="./assets/icons-svg/delete.svg" />
                                                </div>
                                            </div>
                                            @if (field.description && !isDisplayFieldType(field.type)) {
                                            <small>{{field.description}}</small>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="neo-input-wrapper">
                    <label for="footer_content" required>Footer</label>
                    <input pInputText type="text" name="footer_content" id="footer_content" [(ngModel)]="footerContent"
                        (input)="onFooterContentChange($event)" placeholder="Enter footer content">
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isLoading" class="loadingOverlay center-loader">
    <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
    </p-progressSpinner>
</div>

<div class="formBuilder-header" style="display: none;">
    <div class="formBuilder-header_content">
        <h1 class="formBuilder-title">{{ isEditMode ? 'Edit Form' : 'Form Builder' }}</h1>
        <span><button pButton label="Preview" class="p-button-primary" (click)="previewForm()">
            </button>
            <button pButton [label]="isEditMode ? 'Update Form' : 'Save Form'" class="p-button-primary" (click)="saveForm()">
            </button></span>

    </div>
    <div class="form-settings">
        <div class="settings-section">
            <label class="settings-label">Form Type
                <span class="required-star">*</span>
            </label>
            <div class="activeFormType" #target>
                <p-select [options]="categories" [(ngModel)]="selectedCategory" placeholder="Select a category"
                    (onChange)="onCategoryChange(target, $event)" [style]="{'width':'200px'}" optionLabel="label"
                    optionValue="value" [disabled]="isEditMode">
                </p-select>
            </div>
        </div>
        <div class="settings-section">
            <label class="settings-label">Form Name
                <span class="required-star">*</span>
            </label>
            <div class="settings-input">
                <input type="text" [(ngModel)]="formSettings.formName" (input)="onFormNameChange($event)"
                    placeholder="Enter form name">
            </div>
        </div>

        <div class="settings-section">
            <label class="settings-label">Logo
                <span class="required-star">*</span>
            </label>
            <div class="image-upload">
                <div class="image-preview-container">
                    <ng-container *ngIf="formSettings.logoPreview; else showUploadBtn">
                        <img [src]="formSettings.logoPreview" class="upload-preview clickable" alt="Logo"
                            (click)="logoInput.click()" title="Click to change logo">
                    </ng-container>
                    <ng-template #showUploadBtn>
                        <button class="upload-dropzone-btn" [disabled]="uploadingLogo" (click)="logoInput.click()">
                            <em class="pi pi-cloud-upload"></em>
                            <span>200x200px</span>
                        </button>
                    </ng-template>
                    <input type="file" #logoInput style="display: none" (change)="onFileSelected($event, 'logo')"
                        accept="image/png, image/jpeg, image/jpg">
                </div>
            </div>
        </div>

        <div class="settings-section">
            <label class="settings-label">Cover Image</label>
            <div class="image-upload">
                <div class="image-preview-container">
                    <ng-container *ngIf="formSettings.coverPreview; else showCoverUploadBtn">
                        <img [src]="formSettings.coverPreview" class="upload-preview cover-preview clickable"
                            alt="Cover" (click)="coverInput.click()" title="Click to change cover">
                    </ng-container>
                    <ng-template #showCoverUploadBtn>
                        <button class="upload-dropzone-btn" [disabled]="uploadingCover" (click)="coverInput.click()">
                            <em class="pi pi-cloud-upload"></em>
                            <span>1200x400px</span>
                        </button>
                    </ng-template>
                    <input type="file" #coverInput style="display: none" (change)="onFileSelected($event, 'cover')"
                        accept="image/png, image/jpeg, image/jpg">
                </div>
            </div>
        </div>
    </div>

    <div class="form-builder-content">
        <div class="form-component">
            <div class="form-card">
                <div class="form-card-heading">Form Components</div>
                <div class="tab-header">
                    <div class="tab" [class.active]="selectedTab === 'sections'" (click)="selectTab('sections')">
                        Sections
                    </div>
                    <div class="tab" [class.active]="selectedTab === 'fields'" (click)="selectTab('fields')">
                        Fields
                    </div>
                </div>
                <div *ngIf="selectedTab === 'sections'" class="sections-content">
                    <div class="section-title">Available Sections</div>
                    <div cdkDropList #availableSections="cdkDropList" id="availableSectionsList"
                        [cdkDropListData]="availableFormFields" [cdkDropListConnectedTo]="['formLayout']"
                        (cdkDropListDropped)="drop($event)" class="sections-list">
                        <div *ngFor="let section of availableFormFields; trackBy: trackById" cdkDrag [cdkDragData]="section"
                            class="section-card">
                            <div class="section-header">
                                <div class="section-name">
                                    {{ section.section_label }}
                                    <em class="pi pi-grip-vertical drag-handle"></em>
                                </div>
                                <div class="section-count">
                                    {{ section.section_form_fields.length }} fields
                                </div>
                            </div>
                            <div class="drag-placeholder" *cdkDragPlaceholder></div>
                        </div>
                    </div>                    
                    <div *ngIf="availableFormFields.length === 0" class="no-sections-message">
                        <p>All sections have been added to the form.</p>
                    </div>
                </div>

                <div *ngIf="selectedTab === 'fields'" class="fields-content">
                    <div *ngFor="let section of fieldsData" class="section-fields">
                        <div class="section-header" (click)="toggleSection(section)">
                            <div class="field-section">
                                <span class="section-name">
                                    {{ section.section_label }}
                                    <i [class]="section.expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
                                </span>
                            </div>
                        </div>

                        <div *ngIf="section.expanded" cdkDropList [id]="'fields_' + section.section_id"
                            [cdkDropListData]="section.section_form_fields"
                            [cdkDropListConnectedTo]="getConnectedFieldsList(section.section_id)"
                            (cdkDropListDropped)="drop($event)" class="fields-list">

                            <div *ngFor="let field of getVisibleFields(section)" class="field-card"
                                [class.disabled]="field['disabled']"
                                [class.group-field]="field.element_type === 'group'" cdkDrag [cdkDragData]="field">

                                <div class="field-wrapper">
                                    <div class="field-main-info">
                                        <span class="field-name">{{ field.label }}</span>
                                        <div class="field-badges">
                                            <span class="type-badge">{{ field.type || field.element_type }}</span>
                                            <span *ngIf="field.parent_group" class="group-badge">
                                                {{ field.group_label }}
                                            </span>
                                        </div>
                                    </div>
                                    <i class="pi pi-grip-vertical drag-handle"></i>
                                </div>

                                <div *cdkDragPlaceholder class="field-placeholder"></div>
                            </div>
                            <div *ngIf="getVisibleFields(section).length === 0" class="empty-section">
                                No fields available in this section
                              </div>
                            <div *ngIf="section.section_form_fields.length === 0" class="empty-section">
                                No fields available in this section
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-layout">
            <div class="form-card">
                <div class="form-card-heading">Form Layout</div>
                <div class="form-layout-content">
                    <textarea class="header-section" [(ngModel)]="headerContent" (input)="onHeaderContentChange($event)"
                        placeholder="Enter header content" (input)="adjustTextareaHeight($event)">
                    </textarea>
                    <div class="form-layout-section">
                        <div cdkDropList id="formLayout" #formLayout="cdkDropList"
                            [cdkDropListData]="formLayoutSections" [cdkDropListConnectedTo]="['availableSectionsList']"
                            (cdkDropListDropped)="drop($event)" class="layout-container">

                            <div *ngIf="formLayoutSections.length === 0" class="empty-layout">
                                Drag sections here to build your form
                            </div>

                            <div *ngFor="let section of formLayoutSections; let i = index; trackBy: trackById" cdkDrag
                                [cdkDragData]="section" class="layout-section">
                                <div class="section-header">
                                    <span>{{ section.section_label }}</span>
                                    <div class="section-actions">
                                        <button pButton icon="pi pi-trash" class="p-button-text p-button-danger"
                                            (click)="deleteSection(i)">
                                        </button>
                                        <em class="pi pi-grip-vertical drag-handle"></em>
                                    </div>
                                </div>

                                <div cdkDropList [id]="'sectionFields_' + section.section_id"
                                    [cdkDropListData]="section.section_form_fields"
                                    [cdkDropListConnectedTo]="getConnectedFieldsList(section.section_id)"
                                    (cdkDropListDropped)="drop($event)" class="section-fields-container">

                                    <div *ngFor="let field of section.section_form_fields; let j = index; trackBy: trackByFieldId"
                                        cdkDrag [cdkDragData]="field" class="field-item"
                                        [class.group-member]="field.parent_group"
                                        [class.selected]="selectedField === field"
                                        (click)="selectField(field, section)">
                                        <div *ngIf="field.parent_group" class="group-label">
                                            {{ field.group_label }}
                                        </div>

                                        <div class="field-header">
                                            <div class="field-content">
                                                <div class="field-label">{{ field.label }} <span class="field-type">{{
                                                        field.type }}</span></div>
                                                <div *ngIf="field.description" class="field-description">{{
                                                    field.description }}</div>
                                            </div>

                                            <div class="field-actions">
                                                <button pButton icon="pi pi-trash" class="p-button-text p-button-danger"
                                                    (click)="deleteField(i, j)">
                                                </button>
                                                <em class="pi pi-grip-vertical drag-handle"></em>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <textarea class="footer-section" [(ngModel)]="footerContent" (input)="onFooterContentChange($event)"
                        placeholder="Enter footer content" (input)="adjustTextareaHeight($event)">
                    </textarea>
                </div>
            </div>
        </div>

        <div class="form-property">
            <div class="form-card">
                <div class="form-card-heading">Properties</div>
                <div *ngIf="!selectedField" class="empty-properties-message">
                    Select a field to view and edit its properties
                </div>

                <div *ngIf="selectedField" class="field-properties-panel">
                    <div class="property-group">
                        <h3>Basic Properties</h3>
                        <div class="property-item">
                            <label>Field Label</label>
                            <input type="text" pInputText [(ngModel)]="selectedField.label"
                                (ngModelChange)="updateFieldProperty(selectedField, 'label', $event)">
                        </div>

                        <div class="property-item">
                            <label>Description</label>
                            <textarea pInputTextarea [(ngModel)]="selectedField.description"
                                (ngModelChange)="updateFieldProperty(selectedField, 'description', $event)">
                            </textarea>
                        </div>

                        <div class="property-item">
                            <label>Required Field</label>
                            <p-inputSwitch [(ngModel)]="selectedField.is_required"
                                (ngModelChange)="updateFieldProperty(selectedField, 'is_required', $event)">
                            </p-inputSwitch>
                        </div>

                        <div class="property-item">
                            <label>Field Type</label>
                            <div class="field-type-display">{{ selectedField.type || selectedField.element_type }}</div>
                        </div>
                    </div>

                    <div class="property-options"
                        *ngIf="selectedField.type === 'Dropdown' || selectedField.type === 'Radio' || selectedField.type === 'Checkbox'">
                        <h3>Field Options</h3>
                        <div class="options-container">
                            <div *ngFor="let option of selectedField.options || []; let i = index" class="option-item">
                                <div class="option-inputs">
                                    <div class="option-input-field">
                                        <label>Label</label>
                                        <input type="text" pInputText [(ngModel)]="option.label" placeholder="Option Label"
                                            (ngModelChange)="validateOption(i, 'label', $event)">
                                    </div>
                                
                                    <ng-container *ngIf="selectedField.type === 'Checkbox' && false">
                                        <div class="option-input-field">
                                            <label>Value</label>
                                            <p-select [options]="[
                                                {label: 'True', value: 'true'},
                                                {label: 'False', value: 'false'}
                                            ]" [(ngModel)]="option.value" (onChange)="validateOption(i, 'value', $event)"
                                                [style]="{'width':'100%'}">
                                            </p-select>
                                        </div>
                                    </ng-container>
                                
                                    <button pButton icon="pi pi-trash" class="p-button-danger p-button-text" (click)="removeOption(selectedField, i)">
                                    </button>
                                </div>
                            </div>
                            <button pButton label="Add Option" 
                                icon="pi pi-plus" 
                                class="p-button-primary"
                                (click)="addNewOption()"
                                *ngIf="true">
                            </button>
                        </div>
                    </div>

                    <div class="property-group" *ngIf="selectedField.parent_group">
                        <h3>Group Properties</h3>
                        <div class="property-item">
                            <label>Group Name</label>
                            <input type="text" pInputText [value]="selectedField.group_label" disabled>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<p-drawer *ngIf="selectedField" [(visible)]="showFieldProperties" styleClass="p-drawer-lg" [style]="{width: '500px'}"
    [showCloseIcon]="false" [closeOnEscape]="false" [dismissible]="false" position="right">
    <div class="neo-sidebar">
        <div class="neo-sidebar-header">
            <div class="header">Properties</div>
        </div>
        <div class="neo-sidebar-content neo-scrollbar">
            <div class="neo-input-wrapper">
                <label for="field_label" required>Label</label>
                <input type="text" id="field_label" pInputText [(ngModel)]="selectedField.label" [disabled]="isSystemField(selectedField)" 
                    pTooltip="This field is system-controlled label cannot be edited."
                    [tooltipDisabled]="!isSystemField(selectedField)"
                    tooltipPosition="top"
                    [class.system-input-field]="isSystemField(selectedField)"
                    (ngModelChange)="updateFieldProperty(selectedField, 'label', $event)" placeholder="Enter field label (e.g., First Name)">
            </div>
            <div class="neo-input-wrapper">
                <label for="field_description">{{ isDisplayFieldType(selectedField.type) ? 'Content' : 'Description' }}</label>
                <textarea id="field_description" pInputTextarea [(ngModel)]="selectedField.description"
                    [rows]="isDisplayFieldType(selectedField.type) ? 12 : 5"
                    (click)="trackParagraphCursor('field_description')"
                    (keyup)="trackParagraphCursor('field_description')"
                    (ngModelChange)="updateFieldProperty(selectedField, 'description', $event)"
                    [placeholder]="isDisplayFieldType(selectedField.type) ? DISPLAY_FIELD_CONTENT_PLACEHOLDER : 'Provide a short description or instructions'">
                </textarea>
                <small class="content-counter" *ngIf="isDisplayFieldType(selectedField.type)"
                    [class.near-limit]="(selectedField.description || '').length > DISPLAY_FIELD_DESCRIPTION_MAX_LENGTH * 0.9">
                    {{ (selectedField.description || '').length }} / {{ DISPLAY_FIELD_DESCRIPTION_MAX_LENGTH }} characters
                </small>
            </div>

            <div class="token-picker-actions" *ngIf="isDisplayFieldType(selectedField.type)">
                <button type="button" class="label-action" (click)="togglePlaceholderPicker('selected-field')">{{ showPlaceholderPicker && placeholderTarget === 'selected-field' ? 'Close Placeholder' : 'Add Placeholder' }}</button>
                <div class="token-picker-panel" *ngIf="showPlaceholderPicker && placeholderTarget === 'selected-field'">
                    <p class="token-picker-hint" *ngIf="availableParagraphTokens.length">
                        Click a field to add it where your cursor is.
                    </p>
                    <button type="button" class="token-chip" *ngFor="let entry of availableParagraphTokens"
                        (click)="insertSelectedPlaceholder(entry.token)">{{ entry.label }}</button>
                    <p class="token-picker-hint" *ngIf="!availableParagraphTokens.length">
                        Add the fields you want to use to this form first.
                    </p>
                </div>

                <small class="token-picker-warning"
                    *ngIf="requiredFieldHint(selectedField.description)">
                    {{ requiredFieldHint(selectedField.description) }}
                </small>
            </div>
            @if (!isDisplayFieldType(selectedField.type) && selectedField.name !== 'email_id' && selectedField.name !== 'confirm_email_id' && selectedField.name !== "offer_acceptance" && selectedField.name !== "final_recommendation") {
                <div class="neo-input-wrapper">
                    <label for="field_description">Required</label>
                    <p-select inputId="form_type" [options]="[{label: 'Yes', value: true}, {label: 'No', value: false}]"
                        [(ngModel)]="selectedField.is_required" (ngModelChange)="updateFieldProperty(selectedField, 'is_required', $event)"
                        [style]="{'width':'100%'}" optionLabel="label" optionValue="value" placeholder="Select if this field is mandatory">
                    </p-select>
                </div>
            }
            <div class="neo-input-wrapper" *ngIf="!isDisplayFieldType(selectedField.type) && !['radio', 'checkbox', 'file', 'multi-file', 'date picker'].includes(selectedField.type?.toLowerCase() || '')">
                <label for="field_placeholder">Placeholder</label>
                <input type="text" id="field_placeholder" pInputText [(ngModel)]="selectedField.placeholder"
                    (ngModelChange)="updateFieldProperty(selectedField, 'placeholder', $event)" placeholder="Enter a hint for this field (e.g., 'Your full name')">
            </div>
            <div class="neo-input-wrapper" *ngIf="(selectedField.type === 'Dropdown' || selectedField.type === 'Radio' || selectedField.type === 'Checkbox' || selectedField.type === 'Multi-dropdown') && selectedField.name !== 'language_proficiency' && selectedField.name !== 'preferred_role'">
                <label for="field_placeholder">Field Options</label>
                <div class="options-container">
                    <div *ngFor="let option of selectedField.options || []; let i = index" class="option-container">
                        <div class="option-container-header">
                            <input type="text" pInputText [(ngModel)]="option.label" placeholder="Option Label"
                                (ngModelChange)="validateOption(i, 'label', $event)" [disabled]="isSystemField(selectedField)"
                                pTooltip="This field is system-controlled option cannot be edited." [tooltipDisabled]="!isSystemField(selectedField)"
                                tooltipPosition="top" [class.system-input-field]="isSystemField(selectedField)">
                            <button class="neo-danger-btn ghost delete-option-btn" [disabled]="isSystemField(selectedField)"
                                pTooltip="This field is system-controlled option cannot be removed." [tooltipDisabled]="!isSystemField(selectedField)"
                                tooltipPosition="left" (click)="removeOption(selectedField, i)">
                                <em class="pi pi-trash"></em>
                            </button>
                        </div>

                        <div class="option-container-footer">
                            <div class="dependent-fields-count">
                                <i class="pi pi-link"></i>
                                <small>{{selectedField['dependencies']?.[option.value]?.length ? selectedField['dependencies']?.[option.value]?.length : 'No'}} dependent fields</small>
                            </div>

                            <button #dependenciesButton (click)="depedenciesSelect.show()" class="neo-btn outline small"
                                style="margin-top: 1vh; margin-right: 4px;">
                                <em class="pi pi-sliders-h"></em>
                                Customize
                            </button>
                        </div>

                        <p-multiselect #depedenciesSelect [style]="{opacity: '0'}" panelStyleClass="dep_field_multi_select"
                            [ngModel]="selectedField['dependencies']?.[option.value]" [maxSelectedLabels]="1"
                            selectedItemsLabel="{0} fields selected" (onChange)="dependentFieldOptionSelectedFieldsUpdate(option, $event)"
                            [options]="dependentFieldOptions(selectedField)" placeholder="Select the dependent fields" appendTo="body"
                            #ms
                            [panelStyle]="{
                                'min-width': ms.el.nativeElement.offsetWidth + 'px',
                                'max-width': ms.el.nativeElement.offsetWidth + 'px'
                            }">
                            <ng-template let-field pTemplate="item">
                                <div style="display: flex; gap: 4px;">
                                    <div>{{ field.label }}</div>
                                    <div class="custom-badge" *ngIf="field.isCustom">Custom</div>
                                </div>
                            </ng-template>
                        </p-multiselect>
                    </div>
                    <button class="neo-btn outline" (click)="addNewOption()" style="margin-top: 1vh;"
                        [disabled]="isSystemField(selectedField)" pTooltip="This field is system-controlled options cannot be added."
                        [tooltipDisabled]="!isSystemField(selectedField)" tooltipPosition="top">
                        <em class="pi pi-plus"></em>
                        Add Option
                    </button>
                </div>
            </div>
        </div>
        <div class="neo-sidebar-footer">
            <button class="neo-btn" (click)="saveProperties()">Close</button>
        </div>
    </div>
</p-drawer>

<p-drawer [(visible)]="showFormDetailsEdit" styleClass="p-drawer-lg" [style]="{width: '500px'}"
    [showCloseIcon]="false" [closeOnEscape]="false" [dismissible]="false" position="right">
    <div class="neo-sidebar">
        <div class="neo-sidebar-header">
            <div class="header">Basic Details</div>
        </div>
        <div class="neo-sidebar-content neo-scrollbar">
            <div class="neo-input-wrapper">
                <label for="form_name" required>Form Name</label>
                <input pInputText type="text" [(ngModel)]="formSettings.formName" (input)="onFormNameChange($event)"
                    placeholder="Enter form name" [class.invalid]="formSettings.touched && !formSettings.formName">
            </div>
            <div class="neo-input-wrapper" #dialogTarget>
                <label for="form_type" required>Form Type</label>
                <p-select inputId="form_type" [options]="categories" [(ngModel)]="selectedCategory" placeholder="Select a category"
                    (onChange)="onCategoryChange(dialogTarget, $event)" [style]="{'width':'100%'}" optionLabel="label"
                    optionValue="value" [disabled]="isEditMode">
                </p-select>
            </div>
            <div class="neo-input-wrapper">
                <label required>Logo</label>
                <div class="image-upload">
                    <div class="image-preview-container">
                        <ng-container *ngIf="formSettings.logoPreview; else showLogoUploadBtn">
                            <div class="upload-preview clickable" (click)="logoInputNew.click()">
                                <img [src]="formSettings.logoPreview" alt="Logo" title="Click to change logo">
                            </div>
                        </ng-container>
                        <ng-template #showLogoUploadBtn>
                            <button id="logo_image" class="upload-dropzone-btn" [class.invalid]="formSettings.touched && !formSettings.logoPreview" [disabled]="uploadingLogo" (click)="logoInputNew.click()">
                                <img src="assets/icons-svg/upload_file_icon.svg" alt="Upload" />
                                <p class="upload-text">
                                    Drag & Drop your files here or
                                    <span [style]="{ color: '#6944D6', 'text-decoration': 'underline' }">
                                        Choose Files
                                    </span>
                                </p>
                                <p class="format-text">
                                    Recommended png, jpeg and jpg only (Max File Size: 500KB)
                                </p>
                            </button>
                        </ng-template>
                        <input type="file" #logoInputNew style="display: none" (change)="onFileSelected($event, 'logo')"
                            accept="image/png, image/jpeg, image/jpg">
                    </div>
                </div>
            </div>
            <div class="neo-input-wrapper">
                <label for="form_name">Cover Image</label>
                <div class="image-upload">
                    <div class="image-preview-container">
                        <ng-container *ngIf="formSettings.coverPreview; else showCoverUploadBtnNew">
                            <div class="upload-preview clickable" (click)="coverInputNew.click()">
                                <img [src]="formSettings.coverPreview" alt="Cover" title="Click to change cover">
                            </div>
                        </ng-container>
                        <ng-template #showCoverUploadBtnNew>
                            <button id="cover_image" class="upload-dropzone-btn" [disabled]="uploadingCover" (click)="coverInputNew.click()">
                                <img src="assets/icons-svg/upload_file_icon.svg" alt="Upload" />
                                <p class="upload-text">
                                    Drag & Drop your files here or
                                    <span [style]="{ color: '#6944D6', 'text-decoration': 'underline' }">
                                        Choose Files
                                    </span>
                                </p>
                                <p class="format-text">
                                    Recommended png, jpeg and jpg only (Max File Size: 2MB)
                                </p>
                            </button>
                        </ng-template>
                        <input type="file" #coverInputNew style="display: none" (change)="onFileSelected($event, 'cover')"
                            accept="image/png, image/jpeg, image/jpg">
                    </div>
                </div>
            </div>
        </div>
        <div class="neo-sidebar-footer">
            <button class="neo-btn" (click)="validateBasicDetails()">Close</button>
        </div>
    </div>
</p-drawer>

<p-dialog styleClass="preview-dialog" [(visible)]="showPreviewDialog" [modal]="true" [style]="{width: '75vw', height: '80vh'}" [draggable]="false"
    [resizable]="false" [header]="isEditMode ? 'Form Preview - Update' : 'Form Preview - Create'">

    <app-form-preview-v2 *ngIf="showPreviewDialog" [previewMode]="true" [formData]="previewFormData">
    </app-form-preview-v2>

    <ng-template pTemplate="footer">
        <div class="preview-dialog-footer">
            <button pButton label="Cancel" class="neo-btn text" (click)="cancelPreview()">
            </button>
            <button pButton [label]="isEditMode ? 'Update Form' : 'Create Form'" class="neo-btn" (click)="savingForm ? null : confirmSave()" [loading]="savingForm" [disabled]="savingForm">
            </button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog styleClass="create-field-dialog" [(visible)]="showCustomFieldCreateDialog" [modal]="true" [style]="{width: '75vw', height: '80vh'}" [draggable]="false"
    [resizable]="false" [header]="editingCustomField ? 'Custom Field - Update' : 'Custom Field - Create'">
    <div class="neo-sidebar">
        <div class="neo-sidebar-content neo-scrollbar custom-field-create" [formGroup]="customFieldForm">
            <div class="neo-grid neo-grid-cols-2">
                <div class="neo-input-wrapper">
                    <label for="custom_field_label" required>Field Label</label>
                    <input pInputText type="text" id="custom_field_label" placeholder="e.g. Full Name" formControlName="label"
                        [class.is-invalid]="customFieldForm.get('label')?.invalid && (customFieldForm.get('label')?.dirty || customFieldForm.get('label')?.touched)">
                </div>
    
                <div class="neo-input-wrapper">
                    <label for="custom_field_type" required>Field Type</label>
                    <p-select big [options]="customFieldTypeOptions" formControlName="type" id="custom_field_type"
                        placeholder="Select field type" (onChange)="changeCustomFieldType()" appendTo="body"
                        [class.is-invalid]="customFieldForm.get('type')?.invalid && (customFieldForm.get('type')?.dirty || customFieldForm.get('type')?.touched)"></p-select>
                </div>
            </div>
    
            <div class="neo-input-wrapper" *ngIf="!canShowCustomFieldDescriptionOnly">
                <label for="custom_field_placeholder">Input Placeholder</label>
                <input pInputText id="custom_field_placeholder" type="text" formControlName="placeholder"
                    placeholder="e.g. Enter your full name"
                    [class.is-invalid]="customFieldForm.get('placeholder')?.invalid && (customFieldForm.get('placeholder')?.dirty || customFieldForm.get('placeholder')?.touched)">
            </div>

            <div class="neo-input-wrapper">
                <label for="custom_field_description">{{ canShowCustomFieldDescriptionOnly ? 'Content' : 'Description' }}</label>
                <textarea id="custom_field_description" [rows]="canShowCustomFieldDescriptionOnly ? 12 : 2" pInputTextarea formControlName="description"
                    (click)="trackParagraphCursor('custom_field_description')"
                    (keyup)="trackParagraphCursor('custom_field_description')"
                    [placeholder]="canShowCustomFieldDescriptionOnly ? DISPLAY_FIELD_CONTENT_PLACEHOLDER : 'Briefly describe what this field collects or how to fill it'"
                    [class.is-invalid]="customFieldForm.get('description')?.invalid && (customFieldForm.get('description')?.dirty || customFieldForm.get('description')?.touched)">
                    </textarea>
                <small class="content-counter" *ngIf="canShowCustomFieldDescriptionOnly"
                    [class.near-limit]="(customFieldForm.get('description')?.value || '').length > DISPLAY_FIELD_DESCRIPTION_MAX_LENGTH * 0.9">
                    {{ (customFieldForm.get('description')?.value || '').length }} / {{ DISPLAY_FIELD_DESCRIPTION_MAX_LENGTH }} characters
                </small>
            </div>

            <div class="token-picker-actions" *ngIf="canShowCustomFieldDescriptionOnly">
                <button type="button" class="label-action" (click)="togglePlaceholderPicker('custom-field')">{{ showPlaceholderPicker && placeholderTarget === 'custom-field' ? 'Close Placeholder' : 'Add Placeholder' }}</button>
                <div class="token-picker-panel" *ngIf="showPlaceholderPicker && placeholderTarget === 'custom-field'">
                    <p class="token-picker-hint" *ngIf="availableParagraphTokens.length">
                        Click a field to add it where your cursor is.
                    </p>
                    <button type="button" class="token-chip" *ngFor="let entry of availableParagraphTokens"
                        (click)="insertSelectedPlaceholder(entry.token)">{{ entry.label }}</button>
                    <p class="token-picker-hint" *ngIf="!availableParagraphTokens.length">
                        Add the fields you want to use to this form first.
                    </p>
                </div>

                <small class="token-picker-warning"
                    *ngIf="requiredFieldHint(customFieldForm.get('description')?.value)">
                    {{ requiredFieldHint(customFieldForm.get('description')?.value) }}
                </small>
            </div>
    
            <div class="neo-input-wrapper" *ngIf="canShowCustomFieldOptions">
                <label for="field_placeholder" required>Options for This Field</label>
                <div class="options-container" formArrayName="options">
                    <div *ngFor="let option of options.controls; let i = index" [formGroupName]="i" class="add-option-list">
                        <input type="text" pInputText placeholder="e.g. Option Label" formControlName="label" [class.is-invalid]="
                                option.get('label')?.invalid &&
                                (option.get('label')?.dirty || option.get('label')?.touched)
                              ">
                        <button class="neo-danger-btn ghost delete-option-btn" (click)="removeCustomFieldOption(i)">
                            <em class="pi pi-trash"></em>
                        </button>
                    </div>
                    <button class="neo-btn outline" style="margin-top: 1vh;" (click)="addCustomFieldOption()">
                        <em class="pi pi-plus"></em>
                        Add Option
                    </button>
                </div>
            </div>
    
            <div class="neo-grid neo-grid-cols-2" *ngIf="canShowCustomFieldProperties" formGroupName="properties">
                <div class="neo-input-wrapper">
                    <label for="custom_field_file_size" required>Maximum File Size (in MB)</label>
                    <input pInputText id="custom_field_file_size" formControlName="file_max_size" type="number" [min]="1" [max]="5"
                        placeholder="Enter max file size (1–5 MB)" [class.is-invalid]="
                                    customFieldForm.get('properties.file_max_size')?.invalid &&
                                    (customFieldForm.get('properties.file_max_size')?.dirty ||
                                      customFieldForm.get('properties.file_max_size')?.touched)
                                  ">
                </div>
            
                <div class="neo-input-wrapper">
                    <label for="custom_field_file_formats" required>Allowed File Formats</label>
                    <p-multiSelect inputId="custom_field_file_formats" panelStyleClass="custom-field-file-formats"
                        placeholder="Select allowed file types" appendTo="body" [options]="customFieldFileFormatOptions" formControlName="file_format"
                        [maxSelectedLabels]="2" selectedItemsLabel="{0} format(s) selected" 
                        [class.is-invalid]="
                            customFieldForm.get('properties.file_format')?.invalid &&
                            (customFieldForm.get('properties.file_format')?.dirty ||
                                customFieldForm.get('properties.file_format')?.touched)
                        ">
                    </p-multiSelect>
                </div>
            </div>
        </div>
        <div class="neo-sidebar-footer">
            <button class="neo-btn" (click)="saveCustomField($event)" pButton [loading]="savingCustomField"
                [disabled]="savingCustomField || !customFieldFormDetector.isDirty">Save</button>
        </div>
    </div>
</p-dialog>

<p-dialog styleClass="how-to-use-dialog" [(visible)]="showInfoSection" [modal]="true" [resizable]="false" header="Getting Started with Form Builder"
    [draggable]="false" [style]="{width: '60vw', 'max-width': '850px', 'max-height': '75vh'}">
    <div class="neo-sidebar info-dialog">
        <div class="neo-sidebar-content neo-scrollbar">
            <div class="info-section">
                <span class="info-label">Overview</span>
                <span class="info-content">
                    This form builder helps you create and customize forms for various purposes like Registration, Feedback, Offer, and
                    Documentation — all with a simple drag-and-drop experience. You'll find a few default sections and fields to get
                    started quickly. You can add more sections, reorder them, and place fields inside each one as needed.
                </span>
            </div>

            <div class="info-section">
                <span class="info-content">
                    <ol>
                        @for (feature of infoFeatures; track $index) {
                        <li>
                            <strong>{{feature.label}}: </strong>
                            <div class="feature-content">
                                {{feature.content}}
                            </div>
                        </li>
                        }
                    </ol>
                </span>
            </div>

            <div class="info-section footer">
                <span>Ready to start building?</span>
                <button pButton (click)="showInfoSection = false" class="neo-btn" tabindex="-1">Get Started</button>
            </div>
        </div>
    </div>
</p-dialog>

<!-- <p-toast></p-toast> -->
<p-confirmpopup></p-confirmpopup>